"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectEmpty = exports.timeFormatted = exports.date_to_label = exports.months = exports.copy = exports.HHMMSSToSeconds = exports.toHHMMSS = exports.toMMDDYY = exports.sleep = exports.useInterval = exports.editValue = exports.fixedNumbers = exports.uploadTime = exports.toMinutes = exports.date_to_string = exports.arrayToString = exports.classNames = exports.useSave = void 0;
var react_1 = require("react");
var ra_fetch_1 = require("ra-fetch");
function useSave(api, route, model, params, mapping, setRecords, records) {
    if (params === void 0) { params = {}; }
    if (mapping === void 0) { mapping = {}; }
    var Request = ra_fetch_1.useApi(api);
    if (mapping) {
        Request.mapping(mapping);
    }
    if (setRecords && records) {
        Request.records(setRecords, records);
    }
    if (params.id || model.id) {
        return Request.update(route, model, params);
    }
    return Request.store(route, model);
}
exports.useSave = useSave;
function classNames() {
    var classes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classes[_i] = arguments[_i];
    }
    return classes.filter(Boolean).join(' ');
}
exports.classNames = classNames;
function arrayToString(input, delimiter) {
    if (input === void 0) { input = []; }
    if (delimiter === void 0) { delimiter = ' '; }
    return input.join(delimiter).trim();
}
exports.arrayToString = arrayToString;
function date_to_string(date) {
    return date.toISOString().substr(0, 10);
}
exports.date_to_string = date_to_string;
//Needs seconds in string
function toMinutes(time) {
    var minutes = Math.floor(time / 60);
    var seconds = time - minutes * 60;
    seconds === 0 ? seconds = '00' : seconds;
    return minutes + ":" + seconds;
}
exports.toMinutes = toMinutes;
function uploadTime(date) {
    var today = new Date();
    var uploaded = new Date(date);
    today = today.getTime();
    uploaded = uploaded.getTime();
    var uploadedSince = today - uploaded;
    var seconds = Math.floor(uploadedSince / 1000);
    var minutes = Math.floor(seconds / 60);
    var hours = Math.floor(minutes / 60);
    var days = Math.floor(hours / 24);
    if (hours <= 1) {
        return minutes + " " + (minutes === 1 ? 'minuut' : 'minuten') + " geleden";
    }
    if (days < 1) {
        return hours + ' uur geleden';
    }
    return days + " " + (days === 1 ? 'dag' : 'dagen') + " geleden";
}
exports.uploadTime = uploadTime;
function fixedNumbers(num) {
    if (num < 1000) {
        return num;
    }
    return (num / 1E3).toFixed(1) + 'K';
}
exports.fixedNumbers = fixedNumbers;
function editValue(value, paramValue, paramType, setParams) {
    var params = __assign(__assign({}, paramType), { value: value });
    value ? params[paramValue] = value : delete params[paramValue];
    setParams(params);
}
exports.editValue = editValue;
var useInterval = function (callback, delay) {
    var savedCallback = react_1.useRef();
    react_1.useEffect(function () {
        savedCallback.current = callback;
    }, [callback]);
    react_1.useEffect(function () {
        function tick() {
            savedCallback.current();
        }
        if (delay !== null) {
            var id_1 = setInterval(tick, delay);
            return function () { return clearInterval(id_1); };
        }
    }, [delay]);
};
exports.useInterval = useInterval;
var sleep = function (ms) {
    return new Promise(function (resolve) { return setTimeout(resolve, ms); });
};
exports.sleep = sleep;
//Input is normal date time format
var toMMDDYY = function (date) {
    var today = date;
    var yyyy = today.getFullYear();
    var mm = today.getMonth() + 1; // Months start at 0!
    var dd = today.getDate();
    if (dd < 10)
        dd = '0' + dd;
    if (mm < 10)
        mm = '0' + mm;
    var newTime = yyyy + '/' + mm + '/' + dd;
    return newTime.toString();
};
exports.toMMDDYY = toMMDDYY;
var toHHMMSS = function (secs) {
    var sec_num = parseInt(secs, 10);
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor(sec_num / 60) % 60;
    var seconds = sec_num % 60;
    return [hours, minutes, seconds]
        .map(function (v) { return v < 10 ? '0' + v : v; })
        .join(':');
};
exports.toHHMMSS = toHHMMSS;
//Export string with colon (11:11) to seconds
var HHMMSSToSeconds = function (hms) {
    var reg1 = new RegExp('^\\d:\\d{2}$');
    var reg2 = new RegExp('^\\d{2}:\\d{2}$');
    var reg3 = new RegExp('^\\d{2}:\\d{2}:\\d{2}$');
    var reg4 = new RegExp('^\\d{2}:\\d{2}:\\d$');
    if (reg1.test(hms) || reg2.test(hms)) {
        var _a = hms.split(':'), minutes = _a[0], seconds = _a[1];
        return (+minutes) * 60 + (+seconds);
    }
    if (reg3.test(hms) || reg4.test(hms)) {
        var _b = hms.split(':'), hours = _b[0], minutes = _b[1], seconds = _b[2];
        return (+hours) * 60 * 60 + (+minutes) * 60 + (+seconds);
    }
    return parseInt(hms);
};
exports.HHMMSSToSeconds = HHMMSSToSeconds;
function copy(url) {
    document.execCommand('copy');
    var textField = document.createElement('textarea');
    textField.innerText = url;
    textField.style.position = 'fixed';
    textField.style.top = '0';
    textField.style.left = '0';
    textField.style.width = '2em';
    textField.style.height = '2em';
    textField.style.padding = '0';
    textField.style.border = 'none';
    textField.style.outline = 'none';
    textField.style.boxShadow = 'none';
    textField.style.background = 'transparent';
    document.body.appendChild(textField);
    textField.focus();
    textField.select();
    var range = document.createRange();
    range.selectNodeContents(textField);
    var sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
    textField.setSelectionRange(0, textField.value.length);
    var result = document.execCommand('copy');
    if (!result) {
        var isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
        var copyHotkey = isMac ? '⌘C' : 'CTRL+C';
        prompt("Druk " + copyHotkey, url);
    }
    textField.remove();
}
exports.copy = copy;
exports.months = {
    '01': 'jan',
    '02': 'feb',
    '03': 'mrt',
    '04': 'apr',
    '05': 'mei',
    '06': 'jun',
    '07': 'jul',
    '08': 'aug',
    '09': 'sep',
    '10': 'okt',
    '11': 'nov',
    '12': 'dec',
};
function date_to_label(date, year) {
    if (year === void 0) { year = false; }
    date = date.split('-');
    var label = date[2] + " " + exports.months[date[1]];
    if (year) {
        label = label + " " + date[0];
    }
    return label;
}
exports.date_to_label = date_to_label;
function timeFormatted(time) {
    var s = time % 60;
    var m = ((time - (time % 60)) / 60) % 60;
    var h = ((time - (time % 3600)) / 3600) % 3600;
    return (h > 9 ? h : '0' + h) + ":" + (m > 9 ? m : '0' + m) + ":" + (s > 9 ? s : '0' + s);
}
exports.timeFormatted = timeFormatted;
//Checks if the object is empty
function ObjectEmpty(obj) {
    return obj && Object.keys(obj).length === 0 && Object.getPrototypeOf(obj) === Object.prototype;
}
exports.ObjectEmpty = ObjectEmpty;
